import { styled } from '@zeiss/beyond-online-react';
import { useTranslation } from 'react-i18next';

import { BaseProps } from './types';
import { UserSearch } from 'src/modules/TenantManagement/components/UserSearch';
import { SearchUsersResponse } from 'src/types/rest/managementPortalApi';

// Autocomplete has a hard coded wrapper which has smaller height than Text Input.
// To prevent button jumping between steps, Autocomplete has to be wrapped into an extra Container.
const Container = styled.div`
  margin-bottom: 26px;
`;

export const Owners = ({ setState, state }: BaseProps) => {
  const { t } = useTranslation(['common']);

  const handleUserSelect = (owners: SearchUsersResponse[]) => {
    setState((prev) => ({
      ...prev,
      owners,
    }));
  };

  return (
    <Container>
      <UserSearch
        handleUserSelect={handleUserSelect}
        id="applicationListOwners"
        label={t('common:glossary.owner_other')}
        restrictToZeissEmailDomain
        selectedUsers={state.owners}
      />
    </Container>
  );
};
